export default {
  path: '/information',
  name: 'information',
  component: () => import('@/pages/information'),
  children: [{
    path: 'news',
    name: 'information_news',
    component: () => import('@/pages/information/news')
  }, {
    path: 'news/:id',
    name: 'information_news_detil',
    component: () => import('@/pages/information/news/details')
  }, {
    path: 'media',
    name: 'information_media',
    component: () => import('@/pages/information/media')
  }, {
    path: 'code',
    name: 'information_code',
    component: () => import('@/pages/information/code')
  }]
}



// WEBPACK FOOTER //
// ./src/router/information.js